import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ReservationService } from '../services/reservation.service';
import { AlertController, LoadingController } from '@ionic/angular';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { TimezoneService } from '../services/timezone.service';
export class ReservationsPage {
    constructor(reservationService, alertController, loadingCtrl, timezoneService, alertCtrl) {
        this.reservationService = reservationService;
        this.alertController = alertController;
        this.loadingCtrl = loadingCtrl;
        this.timezoneService = timezoneService;
        this.alertCtrl = alertCtrl;
        this.uiData = {
            toCancel: null
        };
        this.timesOptions = {
            morning: [0, 12],
            afternoon: [12, 16],
            evening: [16, 23]
        };
        this.filterData = {
            // spec in #453
            times: [{
                    name: 'Morning',
                    isChecked: true,
                    slot: [0, 12]
                }, {
                    name: 'Afternoon',
                    isChecked: true,
                    slot: [12, 16]
                }, {
                    name: 'Evening',
                    isChecked: true,
                    slot: [16, 23]
                }]
        };
        this.originalData = [];
        this.userTimezone = timezoneService.getUserTimezone();
    }
    joinOnlineClass(purchase) {
        this.joinOnlineAlert(purchase);
    }
    ngOnInit() {
        this.loadAvailableReservations();
    }
    loadAvailableReservations() {
        // this.showLoader();
        this.purchases = [];
        this.reservationService.getAvailable(null).subscribe((data) => {
            this.hideLoader();
            let last = [];
            if (data && data.result) {
                data.result = this.convertPromotionTimezone(data.result);
                data.result
                    .forEach((purchase) => {
                    const promo = purchase.promotion;
                    const classes = purchase.promotion.classes;
                    const sessions = purchase.promotion.classes.sessions;
                    const reservations = purchase.reservations;
                    sessions.forEach((s, index) => {
                        s.purchase = purchase;
                        s.purchase_id = purchase.id;
                        s.promotion = promo;
                        s.classes = classes;
                        s.classReservations = reservations;
                        s.startdate = new Date(s.startdate);
                        s.enddate = new Date(s.enddate);
                        //To capture first session start time
                        if (index == 0) {
                            purchase.startdate = new Date(s.startdate);
                        }
                    });
                    // To Order sessions by date #PBL-920
                    purchase.sessions = lodash.sortBy(sessions, (session) => {
                        return session.startdate;
                    });
                    last.push(purchase);
                });
                last = this.handleMultiplePasses(last);
                last.sort((a, b) => {
                    if (new Date(a.startdate).getTime() > new Date(b.startdate).getTime()) {
                        return 1;
                    }
                    if (new Date(a.startdate).getTime() < new Date(b.startdate).getTime()) {
                        return -1;
                    }
                    return 0;
                });
                this.originalData = last;
                this.purchases = last;
                this.onTimeSlotChange();
            }
        });
    }
    handleMultiplePasses(sessions) {
        sessions.map((classSessions, i) => {
            if (!classSessions.sessions || classSessions.sessions.length <= 0 || classSessions.sessions[0].promotion.pricing_type_id != 5) {
                return;
            }
            let allSessions = [];
            classSessions.sessions[0].classReservations.map((reservation) => {
                let reservedSessions = lodash.cloneDeep(classSessions.sessions);
                let reservations = [reservation];
                reservedSessions.map((session) => {
                    if (session.id == reservation.class_session_id) {
                        session['reservations'] = reservations;
                    }
                    else {
                        delete session['reservations'];
                    }
                });
                allSessions = allSessions.concat(reservedSessions);
            });
            classSessions.sessions = allSessions;
        });
        return sessions;
    }
    convertPromotionTimezone(reservations) {
        let timezoneService = this.timezoneService;
        let hasOnlineClass = this.hasOnlineClass;
        reservations.map(function (reservation) {
            let timezone = reservation.promotion.classes.venue.time_zone;
            let isOnlineClass = hasOnlineClass(reservation);
            reservation.promotion.classes.sessions.forEach(function (session) {
                session['utc_startdate'] = session['startdate'];
                session['utc_enddate'] = session['enddate'];
                session['startdate'] = timezoneService.convertUtcToUserTimezoneWithDayLight(session['startdate'], reservation.promotion.classes.first_session, isOnlineClass, timezone);
                session['enddate'] = timezoneService.convertUtcToUserTimezoneWithDayLight(session['enddate'], reservation.promotion.classes.first_session, isOnlineClass, timezone);
            });
        });
        return reservations;
    }
    buyPromotion(reservation) {
        this.reservationService.reserve(reservation.id, reservation.cancel_id);
    }
    reserveSession(session, sessions) {
        if (!this.uiData.toCancel) {
            this.presentAlert('Reservation', 'All of your purchased sessions are reserved. Please cancel one of your reserved reservations first.');
        }
        else {
            if (this.uiData.toCancel && this.uiData.toCancel.id == session.id) {
                sessions.forEach(s => {
                    s.enableReserved = false;
                });
                delete this.uiData.toCancel;
            }
            else {
                if (this.uiData.toCancel.purchase_id == session.purchase_id) {
                    this.reservationService.reserve(session.id, this.uiData.toCancel.reservations[0].id).subscribe(() => {
                        sessions.forEach(s => {
                            s.enableReserved = false;
                        });
                        delete this.uiData.toCancel;
                        this.loadAvailableReservations();
                    }, (res) => {
                        sessions.forEach(s => {
                            s.enableReserved = false;
                        });
                        if (res.error.code == 'CLASS_FULL') {
                            const tempAlert = this.presentAlert('Activity full', 'Sorry, this activity is full.');
                            tempAlert.then((res) => {
                                this.loadAvailableReservations();
                            });
                        }
                    });
                }
                else {
                    this.presentAlert('Reservation', 'Your new reservation must be made for the same activity listing as the canceled session.');
                }
            }
        }
    }
    cancelSession(session, sessions) {
        const purchase = session.purchase;
        if (purchase.total_class_sessions == purchase.total_reservations) {
            this.presentAlert('Reservation Error', 'Unable to change reservation. You already have ' +
                purchase.total_reservations +
                ' reservation(s) for an activity with ' +
                purchase.total_sessions +
                ' session(s)');
        }
        else {
            sessions.forEach(s => {
                if (!s.reservations || s.reservations[0].id == session.reservations[0].id)
                    s.enableReserved = true;
            });
            this.uiData.toCancel = session;
            this.presentAlert('Reservation', 'You have 1 unreserved session. Please reserve a session, otherwise your original session will be restored.');
        }
    }
    presentAlert(title, msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                header: title,
                message: msg,
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
    joinOnlineAlert(purchase) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let message = '';
            if (purchase.promotion.classes.online_locations_with_passcode[0].pivot.passcode) {
                message = '<p>You are joining your class on Zoom/Google Meet, an external service. ' +
                    'Promoga isn\’t responsible for technical issues on external sites. ' +
                    'Please contact your instructor via our mobile browser real-time chat if you need help.</p>' +
                    '<button class="copy-passcode-btn" id="copy-passcode-button">Copy Passcode</button>';
            }
            else {
                message = '<p>You are joining your class on Zoom/Google Meet, an external service. ' +
                    'Promoga isn\’t responsible for technical issues on external sites. ' +
                    'Please contact your instructor via our mobile browser real-time chat if you need help.</p>';
            }
            const alert = yield this.alertController.create({
                cssClass: 'my-custom-class',
                message: message,
                buttons: [
                    {
                        text: 'Cancel',
                        cssClass: 'btn-cancel',
                        handler: () => {
                            alert.dismiss();
                        }
                    }, {
                        text: 'Continue',
                        cssClass: 'btn-primary',
                        handler: () => {
                            window.open(purchase.promotion.classes.online_locations_with_passcode[0].pivot.url, '_blank');
                        }
                    }
                ]
            });
            yield alert.present();
            const button = document.getElementById('copy-passcode-button');
            button.addEventListener('click', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    yield navigator.clipboard.writeText(purchase.promotion.classes.online_locations_with_passcode[0].pivot.passcode);
                    button['innerText'] = 'Copied!';
                    setTimeout(() => {
                        button['innerText'] = 'Copy Passcode';
                    }, 1000);
                }
                catch (err) {
                    console.error('Failed to copy passcode:', err);
                }
            }));
        });
    }
    onTimeSlotChange() {
        const timeOpt = this.filterData.times.filter((t) => t.isChecked);
        const purchaseList = this.originalData.map(x => (Object.assign({}, x)));
        purchaseList.forEach((purch) => {
            purch['sessions'] = purch['sessions'].filter((item) => {
                const mds = moment(item.startdate);
                let isValid = false;
                for (let i = 0; i < timeOpt.length; i++) {
                    const t = timeOpt[i];
                    const mds_cmp = moment(item.startdate).hour(t.slot[0]).minute(0).subtract(1, 'seconds');
                    const mde_cmp = moment(item.startdate).hour(t.slot[1]).minute(0).add(1, 'seconds');
                    isValid = mds.isSameOrAfter(mds_cmp) && mds.isBefore(mde_cmp);
                    if (isValid) {
                        break;
                    }
                }
                return isValid;
            });
        });
        this.purchases = purchaseList;
    }
    showLoader() {
        this.loadingCtrl.create({
            message: 'Loading...'
        }).then((res) => {
            res.present();
            res.onDidDismiss().then((dis) => { });
        });
    }
    hideLoader() {
        this.loadingCtrl.dismiss();
    }
    hasOnlineClass(cls) {
        if (cls.promotion.classes.medium && cls.promotion.classes.medium.length == 2 &&
            cls.medium && cls.medium.name == 'ONSITE') {
            return false;
        }
        if (cls.promotion.classes.hasOwnProperty('online_locations')) {
            if (cls.promotion.classes.online_locations.length > 0) {
                return true;
            }
            else
                return false;
        }
        else
            return false;
    }
    getClassDuration(cls) {
        if (cls.hasOwnProperty("promotion")) {
            if (cls.promotion.hasOwnProperty("upcoming_sessions")) {
                if (cls.promotion.upcoming_sessions.length > 0) {
                    let mstartdate = moment(cls.promotion.upcoming_sessions[0].startdate);
                    let menddate = moment(cls.promotion.upcoming_sessions[0].enddate);
                    let duration = moment.duration(menddate.diff(mstartdate));
                    let minutes = duration.asMinutes();
                    return minutes;
                }
                else
                    return 0;
            }
            else
                return 0;
        }
        else
            return 0;
    }
    getSessionDates(cls) {
        if (cls.hasOwnProperty("promotion")) {
            if (cls.promotion.classes.hasOwnProperty("sessions")) {
                if (cls.promotion.classes.sessions.length > 0) {
                    let all_enddates = cls.promotion.classes.sessions.map((session) => moment(session.enddate));
                    return all_enddates;
                }
                else {
                    return [];
                }
            }
            else
                return [];
        }
        else
            return [];
    }
    todayListItems(dates) {
        return dates.filter((date) => moment().isSame(date, 'day'));
    }
    futureDateItems(dates) {
        return dates.filter((date) => moment(date).isAfter(moment()));
    }
    getOnlineClassState(cls) {
        // nonexistent, expired, current, pending.
        if (cls.promotion.classes.medium && cls.promotion.classes.medium.length == 2 &&
            cls.medium && cls.medium.name == 'ONSITE') {
            return 'nonexistent';
        }
        if (cls.promotion.classes.hasOwnProperty('online_locations')) {
            if (cls.promotion.classes.online_locations.length > 0) {
                let minutes = this.getClassDuration(cls);
                let sessionDates = this.getSessionDates(cls);
                if (sessionDates.length > 0) {
                    let maxDate = moment.max(sessionDates);
                    if (maxDate.isBefore(moment())) {
                        return 'expired';
                    }
                    let all_today = this.todayListItems(sessionDates);
                    if (all_today.length > 0) {
                        let today_first_session = all_today[0];
                        let current_start_time = moment(today_first_session).subtract('minutes', minutes + 10);
                        let current_end_time = moment(today_first_session);
                        if (moment().isAfter(current_start_time) && moment().isBefore(current_end_time)) {
                            return 'current';
                        }
                        else {
                            return 'pending';
                        }
                    }
                    else {
                        let all_future = this.futureDateItems(sessionDates);
                        if (all_future.length > 0) {
                            return 'pending';
                        }
                    }
                }
                else {
                    return 'expired';
                }
            }
            else {
                return 'nonexistent';
            }
        }
        else {
            return 'nonexistent';
        }
    }
    checkSessionExpiration(classSession) {
        if (classSession.promotion.session_value > 1) {
            return this.getSessionState(classSession) != 'expired';
        }
        else {
            let reservationId = classSession.classReservations[0].class_session_id;
            let session = classSession.classes.sessions.find(row => row.id == reservationId);
            return session && this.getSessionState(classSession) != 'expired' && this.getSessionState(session) != 'expired';
        }
    }
    checkPurchaseExpiration(purchase) {
        let unExpiredSession = purchase.sessions.find(session => this.checkSessionExpiration(session) == true);
        return unExpiredSession ? true : false;
    }
    getSessionState(session) {
        let session_start = moment.utc(session.utc_startdate);
        let now = moment.utc();
        let session_end = moment.utc(session.utc_enddate);
        if (session_end.isBefore(now)) {
            return 'expired';
        }
        let before_ten_mins_start_time = session_start.subtract('minutes', 10);
        if (moment.utc().isAfter(before_ten_mins_start_time) && moment.utc().isBefore(session_end)) {
            return 'current';
        }
        else {
            return 'pending';
        }
    }
    openTooltip(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            event.stopPropagation();
            const alert = yield this.alertCtrl.create({
                message: 'Online events are displayed in your local timezone.',
                buttons: ['OK']
            });
            yield alert.present();
        });
    }
}
